export const MaleIcon = ({ size = 16, color = "#FE964A" }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_11994_10632)">
        <path
          d="M10.2284 12.2789C10.1847 11.6838 10.1724 11.0867 10.1915 10.4903L10.1908 10.5165C10.7237 9.9639 11.0561 9.24869 11.135 8.48504L11.1364 8.47017C11.3766 8.45033 11.7555 8.21658 11.866 7.29008C11.8991 7.13052 11.8864 6.96485 11.8294 6.8122C11.7724 6.65954 11.6733 6.52612 11.5437 6.42733L11.5416 6.42592C11.9326 5.25008 12.7444 1.61208 10.0392 1.23667C9.76086 0.747917 9.04828 0.5 8.12178 0.5C4.41507 0.568 3.96811 3.29862 4.77844 6.42592C4.64747 6.52533 4.54757 6.66004 4.49048 6.81424C4.4334 6.96844 4.42149 7.13573 4.45615 7.29646L4.45544 7.29079C4.56878 8.21587 4.9449 8.45104 5.18503 8.47087C5.26936 9.24304 5.61236 9.96398 6.15828 10.5165C6.17579 11.1234 6.16207 11.7308 6.11719 12.3362L6.12074 12.2789C5.38548 14.2509 0.435651 13.697 0.208984 17.5H16.1167C15.8887 13.697 10.9615 14.2509 10.2277 12.2789H10.2284Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_11994_10632">
          <rect
            width="15.5833"
            height="17"
            fill="white"
            transform="translate(0.208984 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
